import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import AdditionalInfoSkeleton from "./skeletons/AdditionalInfoSkeleton.jsx";
import Policy from "./Policy.jsx";
import Card from "../common/Card.jsx";

const Container = styled.div({
  display: "flex",
  justifyContent: "space-between",
  columnGap: 16,
  "@media (max-width: 1100px)": {
    display: "block",
  },
});

const AdditionalInfo = ({
  loading,
  eventData,
  inModal,
  hasAdditionalInfoSection,
}) => {
  const [leftComponents, setLeftComponents] = useState([]);
  const [rightComponents, setRightComponents] = useState([]);

  useEffect(() => {
      if (!loading && eventData) {
          const components = [];
      eventData&&componentsToRender(eventData,components);
          const [left, right] = balanceComponents(components);
      setLeftComponents(left);
          setRightComponents(right);
      }
  }, [eventData,loading]);

    const componentsToRender = (event, components) => {
        // Duration and Intermission
        if (event.hasDurationIntermission) {
            components.push(
                <Container>
                    {event.durationIntermissionData.map(
                        ({ title, icon, value }, index) =>
                            value > 0 && (
                                <Card key={index} title={title} icon={icon}>
                                    <div style={{fontSize: 14}}>{`${value} ${playdetailsv2_resources.Minutes}`}</div>
                                </Card>
                            )
                    )}
                </Container>
            );
        }

        //Cancellation Policy
        if (event.hasCancellationPolicySection) {
            components.push(
                <Card
                    title={cancellationpolicy_resources.CancellationPolicyHeaderText}
                    icon="/Site/images/icons/eventpage/cancellation.svg"
                >
                    <Policy
                        allowCancel={event.allowCancel}
                        allowUpdate={event.allowUpdate}
                        producerName={event.producerName}
                    />
                </Card>
            );
        }

        //Accessibility
        if (event.hasAccessibilitySection) {
            components.push(
                <Card
                    icon="/Site/images/icons/EventPage/accessibility.svg"
                    title={playdetailsv2_resources.Accessibility}
                >
                    <div className="r_accessibilityList">
                        {event.accessibilityEnabledOptions.map((option, index) => (
                            <span className="r_accessibilityOption" key={index} style={{fontSize: 14}}>
                                <span className="r_green"></span> {option}
                            </span>
                        ))}
                    </div>
                </Card>
            );
        }

        // Seats and Parking
        if (event.hasSeatsParkingSection) {
            components.push(
                <Container>
                    {event.seatsParkingData.map(({ title, icon, available }, index) => (
                        <Card key={index} title={title} icon={icon}>
                            <div style={{fontSize: 14}}>{available
                                ? playdetailsv2_resources.Available
                                : playdetailsv2_resources.Unavailable}</div>
                        </Card>
                    ))}
                </Container>
            );
        }

        //Access Info
        if (event.hasAccessInfoSection) {
            components.push(
                <Card
                    title={playdetailsv2_resources.UIAccessInfoLabelText}
                    icon="/Site/images/icons/EventPage/venueAccess.svg"
                    htmlContent={unescape(event.accessInfo)}
                    extraContentClass="r_accessInfotext"
                />
            );
        }

        // Map
        if (event.hasMapSection) {
            components.push(
                <Card
                    title={playdetailsv2_resources.VenueLocationMaps}
                    icon="/Site/images/icons/svg/linear-location.svg"
                >
                    <div style={{ marginBottom: 8, fontSize: 14 }}>{eventData.venueName}</div>
                    <iframe
                        className="r_googleMaps"
                        referrerPolicy="no-referrer-when-downgrade"
                        allowFullScreen
                        loading="eager"
                        src={event.venueMapUrl}
                    ></iframe>
                </Card>
            );
        }
        return components;
    };
  const balanceComponents = (components) => {
    if (!components.length) return [[], []];

    const halfIndex = Math.ceil(components.length / 2);
    return [components.slice(0, halfIndex), components.slice(halfIndex)];
  };

  const renderContent = () => (
    <div id="r_additionalContent" className="r_additionalContent">
      <div className="r_additionalContentColumn">{leftComponents}</div>
      <div className="r_additionalContentColumn">{rightComponents}</div>
    </div>
  );

  if (loading) return <AdditionalInfoSkeleton inModal={inModal} />;

  if (hasAdditionalInfoSection)
    return (
      <div className="EventPageAdditionalInfo" style={inModal && {padding:0}}>
        {inModal ? (
          renderContent()
        ) : (
          <Card
            title={playdetailsv2_resources.UsefulInfo}
            id="r_infoContainer"
            size="bold"
            noContentPadding
            noMargin
          >
            {renderContent()}
          </Card>
        )}
      </div>
    );

  return "";
};

export default AdditionalInfo;
